import { observer, inject } from "mobx-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { Button, Modal, Text, TextInput } from "../../UI";
import { DatePicker, LocalizationProvider } from "@material-ui/pickers";
import DateFnsUtils from "@material-ui/pickers/adapter/date-fns";
import calendarImg from "../../assets/img/calendar.svg";
import { Box, BoxHeader, InnerBox, SaveSuccess } from "../Common";
import addImg from "../../assets/img/add-circle.svg";
import { he } from "date-fns/locale";
import DefectList from "../Applies/DefectList";
import { ClipLoader } from "react-spinners";
import MobileHeader from "../../layouts/MobileHeader";
import { useLocation, useNavigate } from "react-router-dom";
import MessageNotification, {
  useMessageNotification,
  MessageType,
} from "../MessageNotification";

const NewRepairPage = ({
  date,
  applier,
  showSuccessModal,
  doValidation,
  setShowSuccessModal,
  handleDefectChange,
  prevStep,
  error,
  isSaving,
  handleAddApply,
  handleDateChange,
  department,
  defectList,
  handleChange,
}) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation("applies");
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const { messageNotification, setMessageNotification } =
    useMessageNotification();

  const handleDateClick = (event) => {
    setOpen((open) => !open);
    setAnchorEl(event.currentTarget);
  };

  const handleImgDateClick = () => {
    setOpen((open) => !open);
  };

  const goNewDefect = () => {
    location?.state?.bedek === true
      ? navigate("/bedek/mobile-new-defect", { state: { department } })
      : navigate("/tenant/mobile-new-defect", { state: { department } });
  };

  useEffect(() => {
    if (!!error) {
      setMessageNotification({
        text: t(error),
        show: true,
        type: MessageType.ERROR,
      });
    } else {
      setMessageNotification({
        show: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <>
      <MobileHeader title={t("back_to_applies")} navigateTo={"applies"} />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Box style={{ width: "100%", height: "100vh" }}>
          <InnerBox style={{ padding: 0, borderRadius: 18 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <BoxHeader borderColor={theme.color.gray30} flexBasis={"unset"}>
                <Text.BM
                  color={theme.color.navy}
                  style={{
                    textAlign: "start",
                  }}
                >
                  {t("new_apply", { type: department })}
                </Text.BM>
              </BoxHeader>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  height: "69vh",
                  overflowY: "auto",
                  padding: "10px 20px",
                  borderColor: theme.color.gray30,
                }}
              >
                <BoxHeader
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 20,
                    width: "100%",
                    padding: 0,
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <LocalizationProvider
                      dateAdapter={DateFnsUtils}
                      locale={he}
                    >
                      <DatePicker
                        closeOnSelect={true}
                        mask="__/__/__"
                        inputFormat="dd/MM/yy"
                        value={selectedDate}
                        onChange={(date) => {
                          setSelectedDate(date);
                          handleDateChange(date);
                          setOpen(false);
                        }}
                        onClose={() => setOpen(false)}
                        open={open}
                        PopperProps={{
                          placement: "bottom-end",
                          positionFixed: true,
                          anchorEl: anchorEl,
                        }}
                        renderInput={({ inputRef, inputProps }) => (
                          <div
                            style={{
                              flex: 1,
                            }}
                          >
                            <TextInput
                              refProp={inputRef}
                              divStyle={{
                                display: "flex",
                                padding: "10px 0",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                height: 50,
                              }}
                              {...date}
                              variant="outlined"
                              label={t("apply_date")}
                              onClick={handleDateClick}
                              onEndImgClick={handleImgDateClick}
                              endImg={calendarImg}
                              valid={!date.error}
                              helperText={date.helperText}
                            ></TextInput>
                          </div>
                        )}
                      />
                    </LocalizationProvider>
                  </div>
                  <div style={{ width: "100%" }}>
                    <TextInput
                      divStyle={{
                        display: "flex",
                        padding: "10px 0",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: 12,
                        alignSelf: "stretch",
                        height: 50,
                      }}
                      {...applier}
                      variant="outlined"
                      onBlur={handleChange("APPLICANTNAME")}
                      onChange={handleChange("APPLICANTNAME")}
                      label={t("applier")}
                      valid={!applier.error}
                      helperText={applier.helperText}
                    ></TextInput>
                  </div>
                </BoxHeader>
                <Text.BM color={theme.color.navy}>{t("defect_list")}</Text.BM>
                <div style={{ width: "100%" }}>
                  <DefectList
                    items={defectList}
                    department={department}
                    validate={doValidation}
                    prevStep={prevStep}
                    inList={true}
                    isBedek={location?.state?.bedek === true}
                    handleDefectChange={handleDefectChange}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: 20,
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 70,
                    width: "100%",
                    borderTop: "1px solid rgba(234, 238, 244, 1)",
                  }}
                >
                  <Button
                    onClick={goNewDefect}
                    style={{
                      backgroundColor: theme.color.primary,
                      padding: "10px 14px",
                      border: `1px solid ${theme.color.white}`,
                      color: theme.color.white,
                      height: 40,
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          mask: `url(${addImg}) no-repeat center / contain`,
                          backgroundColor: theme.color.white,
                          width: 20,
                          height: 20,
                          marginInlineEnd: 12,
                        }}
                      ></div>
                      {t("add_defect")}
                    </div>
                  </Button>
                </div>
              </div>
            </div>
            {defectList.length > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 10,
                  flexDirection: "column",
                  height: 70,
                  width: "100%",
                  backgroundColor: theme.color.white,
                  borderTop: "1px solid rgba(234, 238, 244, 1)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 16,
                  }}
                >
                  <Button
                    style={{
                      width: 140,
                      marginTop: 0,
                    }}
                    onClick={handleAddApply}
                    disabled={isSaving}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      {isSaving && (
                        <ClipLoader color={theme.color.white} size={20} />
                      )}
                      {t("send_apply")}
                    </div>
                  </Button>
                  <Button
                    onClick={() =>
                      location?.state?.bedek === true
                        ? navigate("/bedek/applies")
                        : navigate("/tenant/applies")
                    }
                    style={{
                      width: 110,
                      backgroundColor: theme.color.white,
                      border: `1px solid ${theme.color.primary}`,
                      color: theme.color.primary,
                      marginTop: 0,
                    }}
                  >
                    {t("cancel_apply")}
                  </Button>
                </div>
              </div>
            )}
          </InnerBox>
        </Box>
      </div>
      {messageNotification.show && (
        <MessageNotification
          type={MessageType.ERROR}
          text={messageNotification.text}
          onClose={() => {
            setMessageNotification({
              show: false,
            });
          }}
        />
      )}
      {showSuccessModal && (
        <Modal
          isMobile={true}
          onClose={() => {
            setShowSuccessModal(false);
            location?.state?.bedek === true
              ? navigate("/bedek/applies")
              : navigate("/tenant/applies");
          }}
        >
          <SaveSuccess
            onButtonClick={() =>
              location?.state?.bedek === true
                ? navigate("/bedek/applies")
                : navigate("/tenant/applies")
            }
            buttonLabel={t("applay_save_successs_button")}
            textLabel={t("applay_save_successs_text")}
          />
        </Modal>
      )}
    </>
  );
};

export default inject(
  "userStore",
  "tenantsStore",
  "repairPagesStore"
)(observer(NewRepairPage));
